module.exports = __webpack_public_path__ + "static/media/ftn-handelsbanken-auth.2936622f.svg";